import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast'; // ✅ Import toast renderer
import LoginPage from './pages/Login';
import LogsPage from './pages/Logs';
import AdminSettingsPage from './pages/AdminSettings';
import { isLoggedIn } from './utils/auth';
import ActivityLogsPage from './pages/ActivityLogs';
import NASManagementPage from './pages/NASManage';
import LicStatusPage from './pages/LicStatus';
import Dashboard from './pages/Dashboard';
import VoiceCDRPage from './pages/VoiceCDRPage';
import SIPLogsPage from './pages/SIPLogsPage';
import VoiceClientPage from './pages/VoiceClients';
import ActiveCallsPage from './pages/ActiveCalls';
import RateCardPage from './pages/RateCardPage';
import NetworkManagement from './pages/NetworkManage';
import RadiusSourceManagementPage from './pages/RadiusSourceManagementPage';
import LoginChoice from './pages/LoginChoice';
import RadiusLogin from './pages/RadiusLogin';
import RadiusPrivateRoute from './components/PrivateRadiusRoute';
import RadiusDashboard from './pages/radius/Dashboard';
import RadiusProfile from './pages/radius/Profile';
import RadiusOverview from './pages/radius/Overview';
import ResellersList from './pages/radius/resellers/ResellersList';
import ResellerDetail from './pages/radius/resellers/ResellerDetail';
import ClientsList, { ClientDetail } from './pages/radius/clients/Clients';
import ServicesList from './pages/radius/services/ServicesList';
import NASList from './pages/radius/nas/NASList';
import Invoices from './pages/radius/billing/Invoices';
import Payments from './pages/radius/billing/Payments';
import Wholesale from './pages/radius/billing/Wholesale';
import COASessions from './pages/radius/coa/Sessions';
import OnlineUsers from './pages/radius/monitoring/OnlineUsers';
import Accounting from './pages/radius/monitoring/Accounting';
import UsageStats from './pages/radius/monitoring/UsageStats';
import AuthLogs from './pages/radius/monitoring/AuthLogs';
import Revenue from './pages/radius/reports/Revenue';
import ClientsAnalytics from './pages/radius/reports/ClientsAnalytics';
import ServiceUsage from './pages/radius/reports/ServiceUsage';
import FinancialSummary from './pages/radius/reports/FinancialSummary';
import Hierarchy from './pages/radius/reports/Hierarchy';
import TopUsers from './pages/radius/reports/TopUsers';
import RadiusSettings from './pages/radius/Settings';
import Jobs from './pages/radius/automation/Jobs';
import UserGroups from './pages/radius/usergroups/UserGroups';
import IPPools from './pages/radius/ippools/IPPools';
import Tickets from './pages/radius/tickets/Tickets';
import TicketDetail from './pages/radius/tickets/TicketDetail';
import ActivityLogs from './pages/radius/ActivityLog';
import MyPlans from './pages/radius/plans/MyPlans';

function App() {
  return (
    <>
      <Router>
        <Routes>
        <Route path="/" element={<LoginPage />} /> {/* Disable for RADIUS Prod */}
        {/* <Route path="/" element={<LoginChoice />} /> */}
        {/* <Route path="/sysadmin/login" element={<LoginPage />} /> */}
        <Route path="/radius/login" element={<RadiusLogin />} />
          <Route path="/logs" element={isLoggedIn() ? <LogsPage /> : <Navigate to="/" />} />
          <Route path="/settings" element={isLoggedIn() ? <AdminSettingsPage /> : <Navigate to="/" />} />
          <Route path="/activity" element={isLoggedIn() ? <ActivityLogsPage /> : <Navigate to="/" />} />
          <Route path="/nas-manage" element={isLoggedIn() ? <NASManagementPage /> : <Navigate to="/" />} />
          <Route path="/lic-status" element={isLoggedIn() ? <LicStatusPage /> : <Navigate to="/" />} />
          <Route path="/dashboard" element={isLoggedIn() ? <Dashboard /> : <Navigate to="/" />} />
          <Route path="/voice/cdr" element={isLoggedIn() ? <VoiceCDRPage /> : <Navigate to="/" />} />
          <Route path="/voice/sip-trace" element={isLoggedIn() ? <SIPLogsPage /> : <Navigate to="/" />} />
          <Route path="/voice/customers" element={isLoggedIn() ? <VoiceClientPage /> : <Navigate to="/" />} />
          <Route path="/voice/active-calls" element={isLoggedIn() ? <ActiveCallsPage /> : <Navigate to="/" />} />
          <Route path="/voice/billing/rates" element={isLoggedIn() ? <RateCardPage /> : <Navigate to="/" />} />
          <Route path="/network/manage" element={isLoggedIn() ? <NetworkManagement /> : <Navigate to="/" />} />
          <Route path="/radius/sources" element={isLoggedIn() ? <RadiusSourceManagementPage /> : <Navigate to="/" />} />
          
     {/* <Route path="dashboard" element={<RadiusDashboard />} />
          <Route path="/radius" element={<RadiusPrivateRoute />}>
     <Route path="overview" element={<RadiusOverview />} />
     <Route path="profile" element={<RadiusProfile />} />

     <Route path="resellers" element={<ResellersList />} />
     <Route path="resellers/:id" element={<ResellerDetail />} />

     <Route path="clients" element={<ClientsList />} />
     <Route path="clients/:id" element={<ClientDetail />} />

     <Route path="services" element={<ServicesList />} />
     <Route path="nas" element={<NASList />} />

     <Route path="billing/invoices" element={<Invoices />} />
     <Route path="billing/payments" element={<Payments />} />
     <Route path="billing/wholesale" element={<Wholesale />} />

     <Route path="coa/sessions" element={<COASessions />} />

     <Route path="monitoring/online-users" element={<OnlineUsers />} />
     <Route path="monitoring/accounting" element={<Accounting />} />
     <Route path="monitoring/usage-stats" element={<UsageStats />} />
     <Route path="monitoring/auth-logs" element={<AuthLogs />} />

     <Route path="reports/revenue" element={<Revenue />} />
     <Route path="reports/clients-analytics" element={<ClientsAnalytics />} />
     <Route path="reports/service-usage" element={<ServiceUsage />} />
     <Route path="reports/financial-summary" element={<FinancialSummary />} />
     <Route path="reports/hierarchy" element={<Hierarchy />} />
     <Route path="reports/top-users" element={<TopUsers />} />

     <Route path="settings" element={<RadiusSettings />} />
     <Route path="automation/jobs" element={<Jobs />} />

     <Route path="user-groups" element={<UserGroups />} />
     <Route path="ip-pools" element={<IPPools />} />

     <Route path="tickets" element={<Tickets />} />
     <Route path="tickets/:id" element={<TicketDetail />} />

     <Route path="activity-logs" element={<ActivityLogs />} />
     <Route path="plans" element={<MyPlans />} />
   </Route> */}
          
        </Routes>
      </Router>

      <Toaster position="top-right" reverseOrder={false} /> {/* ✅ Mount once here */}
    </>
  );
}

export default App;
